const vueDefaultConfig = {
    publicPath: '/',
    outputDir: 'dist',
    assetsDir: 'static',
    lintOnSave: true,
    transpileDependencies: ['vue-echarts', 'resize-detector'],
    //webpack 配置的项目名称
    title: 'Manager MAQ',
    titleSeparator: ' - ',
    titleReverse: false,
    devPort: '9999',
    abbreviation: 'MG**',
    providePlugin: {},
    build7z: false,
    showTipsMenu:['Member','Member List','Deposit Management','Online Deposit'],
    startMessage:'Welcome to Manager'
}

module.exports = vueDefaultConfig
